<template>
  <div>
    <Header :title="$t('profile.title')" />
    <div class="full-page-box">
        <div class="box-item">
            <van-row @click="topage('card')">
                <van-col :span="2">
                    <div class="icon icon1"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" class="text-[#56CBF2]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"></path></svg></div>
                </van-col>
                <van-col :span="15">
                    <van-badge dot><div class="title">{{ $t('profile.item1') }}</div></van-badge>
                    <p class="msg">{{ $t('profile.msg') }}</p>
                </van-col>
                <van-col :span="7">
                    <span v-if="checkCard()" class="status-finish">{{ $t('profile.finish') }}</span>
                    <span v-else class="status-no-finish" >{{ $t('profile.tobecompleted') }}</span>
                </van-col>
            </van-row>
        </div>

        <div class="box-item">
            <van-row @click="topage('usr')">
                <van-col :span="2">
                    <div class="icon icon2"><svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="text-[#F19949]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path><path d="M6 21v-2a4 4 0 0 1 4 -4h3.5"></path><path d="M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"></path></svg></div>
                </van-col>
                <van-col :span="15">
                    <van-badge dot><div class="title">{{ $t('profile.item2') }}</div></van-badge>
                    <p class="msg">{{ $t('profile.msg') }}</p>
                </van-col>
                <van-col :span="7">
                    <span v-if="checkInfo()" class="status-finish">{{ $t('profile.finish') }}</span>
                    <span v-else class="status-no-finish" >{{ $t('profile.tobecompleted') }}</span>
                </van-col>
            </van-row>
        </div>

        <div class="box-item">
            <van-row @click="topage('bank')">
                <van-col :span="2">
                    <div class="icon icon3"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" class="text-[#6FCF96]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"></path></svg></div>
                </van-col>
                <van-col :span="15">
                    <van-badge dot><div class="title">{{ $t('profile.item3') }}</div></van-badge>
                    <p class="msg">{{ $t('profile.msg') }}</p>
                </van-col>
                <van-col :span="7">
                    <span v-if="is_bind" class="status-finish">{{ $t('profile.finish') }}</span>
                    <span v-else class="status-no-finish" >{{ $t('profile.tobecompleted') }}</span>
                </van-col>
            </van-row>
        </div>

        <div class="box-item">
            <van-row  @click="topage('autograph')">
                <van-col :span="2">
                    <div class="icon icon4"><svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="text-[#3884ED]" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M12 20h9"></path><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"></path><path d="m15 5 3 3"></path></svg></div>
                </van-col>
                <van-col :span="15">
                    <van-badge dot><div class="title">{{ $t('profile.item4') }}</div></van-badge>
                    <p class="msg">{{ $t('profile.msg') }}</p>
                </van-col>
                <van-col :span="7">
                    <span v-if="usrdata.signature && usrdata.signature.length > 0" class="status-finish">{{ $t('profile.finish') }}</span>
                    <span v-else class="status-no-finish" >{{ $t('profile.tobecompleted') }}</span>
                </van-col>
            </van-row>
        </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { Toast } from "vant";
import Footer from "@/components/footer/index.vue";
import Header from "@/components/header/index.vue";
export default {
  name: "ProfileView",
  components: { Footer, Header },
  data(){
    return {
        usrdata:{},
        is_bind:false
    }
  },
  created(){
    if(!localStorage.getItem('token')){
      this.$router.push({ name: 'login' });
    } else {
        this.getInfo()
        this.getUserBankInfo()
    }
  },
  methods:{
    topage(val){
        this.$router.push({ name: val }); 
    },
    checkCard(){
        return (this.usrdata.bankName
                && this.usrdata.identification
                && this.usrdata.identificationBack
                && this.usrdata.identificationFront
                && this.usrdata.identificationWithHand
                && this.usrdata.dob
                && this.usrdata.cccd
                && this.usrdata.bankName.length > 0
                && this.usrdata.identification.length > 0
                && this.usrdata.identificationBack.length > 0
                && this.usrdata.identificationFront.length > 0
                && this.usrdata.identificationWithHand.length > 0
                && this.usrdata.dob.length > 0
                && this.usrdata.cccd.length > 0)
    },
    checkInfo(){
        return (
            this.usrdata.education
            && this.usrdata.purpose
            && this.usrdata.house
            && this.usrdata.vehicle
            && this.usrdata.income
            && this.usrdata.address
            && this.usrdata.relationship
            && this.usrdata.nameRelationship
            && this.usrdata.relativesPhone
            && this.usrdata.otherName
            && this.usrdata.otherPhone
            && this.usrdata.otherRelationship
            && this.usrdata.education.length > 0
            && this.usrdata.purpose.length > 0
            && this.usrdata.house.length > 0
            && this.usrdata.vehicle.length > 0
            && this.usrdata.income.toString().length > 0
            && this.usrdata.address.length > 0
            && this.usrdata.relationship.length > 0
            && this.usrdata.nameRelationship.length > 0
            && this.usrdata.relativesPhone.toString().length > 0
            && this.usrdata.otherName.length > 0
            && this.usrdata.otherPhone.toString().length > 0
            && this.usrdata.otherRelationship.length > 0
        )
    },
    getInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.usrdata = res.data
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code == 200){
          if(res.data.is_bank){
            this.is_bind = true;
          }else {
            this.is_bind = false;
          }
        }else{
          Toast(res.msg);
        }
      })
    }
  }
};
</script>
<style scoped>
.box-item{
    border: 1px solid rgb(206 212 218);
    border-radius: 8px;
    padding: 10px;
    width: 94%;
    margin: 10px auto 0;
    line-height: 1.4;
}
.box-item .icon {
    font-size: 24px;
    margin-top: 5px;
}
.box-item .icon1{
    color: rgb(86 203 242);
}
.box-item .icon2{
    color: rgb(241 153 73);
}
.box-item .icon3{
    color: rgb(111 207 150);
}
.box-item .icon4{
    color: rgb(56 132 237);
}
.box-item .title {
    font-weight: 700;
}
.box-item .msg {
    font-size:12px;
}
.box-item .status-finish {
    color: rgb(25 135 83);
}
.box-item .status-no-finish {
    color: red;
}
</style>
